<canvas
    baseChart
    [data]="radarChartData"
    [options]="radarChartOptions"
    [type]="radarChartType"
>
</canvas>